import axios from '../../http';

function initialState() {
  return {
    referralBranch: null,
    userRefId: null,
    userTrackingId: null,
    switchId: null,
    propertyDetails: []
  };
}

const state = initialState();

const getters = {};

const actions = {
  addAction({ commit }, { name, value }) {
    commit('updateActions', { name, value });
  },
  async saveActions({ state, commit, rootState, rootGetters }) {
    const { uid } = rootState.storage;
    const { quote } = rootState.session;
    const url = rootState.history.currentRoute.path;
    const journeyType = rootGetters['session/journeyType'];

    const data = [
      {
        userRefId: quote.switchId,
        referralBranch: process.env.VUE_APP_REFERRER_BRANCH_CODE,
        userTrackingId: uid,
        propertyDetails: [
          ...state.propertyDetails,
          { name: 'URL', value: url },
          { name: 'Journey', value: journeyType }
        ]
      }
    ];

    if (process.env.NODE_ENV == 'development') {
      console.log('trace', JSON.stringify(data, null, 2));
      return commit('resetState');
    }

    try {
      const res = await axios({
        method: 'POST',
        url: '/request/user/track-records',
        data
      });

      commit('resetState');

      return res.data;
    } catch (err) {
      return err;
    }
  }
};

const mutations = {
  updateState(state, value) {
    state = Object.assign(state, value);
  },
  updateActions(state, { name, value }) {
    state.propertyDetails.push({ name, value });
  },
  resetState(state) {
    state = Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
